import { t } from 'i18next';

export enum ScanStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
}

export const getScanStatusLabel = (status: ScanStatus): string => {
  const labels = {
    [ScanStatus.CANCELED]: t('canceled'),
    [ScanStatus.COMPLETED]: t('completed'),
    [ScanStatus.PENDING]: t('pending'),
    [ScanStatus.IN_PROGRESS]: t('inProgress'),
  };

  return labels[status];
};

export const getScanStatusColor = (status: ScanStatus): string => {
  const colors = {
    [ScanStatus.CANCELED]: 'red',
    [ScanStatus.COMPLETED]: 'green',
    [ScanStatus.PENDING]: 'yellow',
    [ScanStatus.IN_PROGRESS]: 'blue',
  };

  return colors[status];
};
